import { POS } from './PosUtil/constants';

const { parseDomain } = require('parse-domain');
const { themes, supportedBrands, supportedBrandNames } = require('../constants/common');

export const brandConsolidationNameOverrides = {
    VRUS: 'VacationRentals',
    LXUS: 'LuxuryRentals'
};

export function getHostFromDomain(fqdn) {
    const parsedDomainObj = parseDomain(fqdn);
    return parsedDomainObj ? parsedDomainObj.domain : null;
}

export function getHostAndTldFromDomain(fqdn) {
    const parsedDomainObj = parseDomain(fqdn);
    if (parsedDomainObj && parsedDomainObj.topLevelDomains) {
        return `${parsedDomainObj.domain}.${parsedDomainObj.topLevelDomains[0]}`;
    }
    return null;
}

export function getBrand(host) {
    const baseHost = getHostFromDomain(host);
    return supportedBrands[baseHost] || 'expedia';
}

export function capitalizeBrand(brand) {
    return supportedBrandNames[brand] || 'Expedia';
}

export function getTheme(host) {
    const baseHost = getHostFromDomain(host);
    return themes[baseHost] || 'eg';
}

export function isUsBrand(siteName) {
    return siteName === 'homeaway_us' || siteName === 'vr' || siteName === 'vrbo';
}

const displayBrands = {
    VRBO: 'Vrbo',
    ABRITEL: 'Abritel',
    FEWO_DIREKT: 'FeWo-direkt',
    BOOKABACH: 'Bookabach',
    EXPEDIA: 'Expedia',
    STAYZ: 'Stayz'
};

const vrboBrandsByLangId = {
    [POS.AUSTRALIA]: displayBrands.STAYZ,
    [POS.HCOM_AUSTRALIA]: displayBrands.STAYZ,
    [POS.HCOM_NEWZEALAND]: displayBrands.BOOKABACH,
    [POS.NEW_ZEALAND]: displayBrands.BOOKABACH,
    [POS.FRANCE]: displayBrands.ABRITEL,
    [POS.GERMANY]: displayBrands.FEWO_DIREKT
};

export const getVrboBrandByPos = (pos) => vrboBrandsByLangId[pos.name] || displayBrands.VRBO;

/**
 * A map of site names to brand names.
 */
const brandBySite = {
    abritel: displayBrands.ABRITEL,
    homelidays_fr: displayBrands.ABRITEL,
    homeaway_nz: displayBrands.BOOKABACH,
    homeaway_au: displayBrands.STAYZ,
    stayz: displayBrands.STAYZ,
    homeaway_de: displayBrands.FEWO_DIREKT,
    homeaway_ar: displayBrands.VRBO,
    homeaway_at: displayBrands.VRBO,
    homeaway_br: displayBrands.VRBO,
    homeaway_co: displayBrands.VRBO,
    homeaway_dk: displayBrands.VRBO,
    homeaway_es: displayBrands.VRBO,
    homeaway_it: displayBrands.VRBO,
    homeaway_nl: displayBrands.VRBO,
    homeaway_no: displayBrands.VRBO,
    homeaway_pt: displayBrands.VRBO,
    homeaway_se: displayBrands.VRBO,
    homeaway_uk: displayBrands.VRBO,
    homeaway_us: displayBrands.VRBO,
    homelidays_es: displayBrands.VRBO,
    homelidays_it: displayBrands.VRBO,
    homeaway_sg: displayBrands.VRBO,
    odhr: displayBrands.VRBO,
    vr: displayBrands.VRBO,
    vrbo: displayBrands.VRBO,
    homeaway_jp: displayBrands.VRBO,
    homeaway_lk: displayBrands.VRBO,
    homeaway_ca: displayBrands.VRBO,
    homeaway_cafr: displayBrands.VRBO
};

export function getDisplayBrand(siteName, brand) {
    return brandBySite[siteName] || capitalizeBrand(brand);
}

export default {
    brandConsolidationNameOverrides,
    getHostFromDomain,
    getHostAndTldFromDomain,
    getBrand,
    capitalizeBrand,
    getTheme,
    isUsBrand,
    getVrboBrandByPos
};
